import '@kerfjs/ui/select/register';

import { PopupMenu } from '@kerfjs/ui/popup-menu';
import { Select } from '@kerfjs/ui/select';
import { ToolbarControlGroup } from '@kerfjs/ui/toolbar-control-group';
import { type SafeHtml } from 'kerfjs';

import type { OrgSavingsT } from '../../data/api.js';
import { savingsSite } from '../../data/state.js';

export function SavingsActions({ savings, part }: { savings: OrgSavingsT | null; part: 'site' | 'export' }): SafeHtml {
  if (part === 'site')
    return (
      <ToolbarControlGroup label="Site Filter" single={true}>
        <Select
          name="savings-site"
          value={savingsSite.value}
          ariaLabel="Filter by Site"
          presentation="toolbar-borderless"
          size="compact"
          triggerWidth="fit-content"
          labelMaxWidth={96}
          focusRingOwner="group"
          choices={[
            { value: '', label: 'All Sites' },
            ...(savings?.sites ?? []).map((site) => ({ value: site.id, label: site.name })),
          ]}
        />
      </ToolbarControlGroup>
    );
  return (
    <ToolbarControlGroup label="Export" content="text" single={true} nestedDropdown={true}>
      <PopupMenu
        text="Export"
        placement="bottom-end"
        rootAttributes={{ 'data-savings-export-menu': '' }}
        items={[
          { label: 'PDF', action: 'export-savings', attributes: { 'data-item-id': 'pdf' } },
          { label: 'Excel (XLSX)', action: 'export-savings', attributes: { 'data-item-id': 'xlsx' } },
        ]}
      />
    </ToolbarControlGroup>
  );
}
